export enum PartType {
  Normal,
  Highlight,
  Link,
  Button,
}
